import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13.098 15.848V2.897l2.576 2.576.849-.849L12.499.6 8.473 4.624l.849.849 2.575-2.576v12.952h1.2zm-9 5.752V8.4h-1.2v14.4h19.2V8.4h-1.2v13.2h-16.8z" fill="#000" /></svg>;